import axios from 'axios';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import {useNavigate} from "react-router-dom";
import {Customer} from "../../Domains/Auth/Types/customer";
import {impersonate, removeImpersonate} from "../../Domains/Auth/Api/UserApi";

export const useGetMe = (): Customer => {
    // retry explicite : cette requête pilote des décisions de routage
    // (ex. isPilotClient) où un échec silencieux (retry:false par défaut au
    // niveau global) est pris à tort pour "customer non pilote" plutôt que
    // "donnée pas encore chargée".
    const {data} =  useQuery(['buId'], async () => {
        const response = await axios.get('/api/customers/bu');
        return response.data;
    }, {
        retry: 3,
    });

    return data;
};

export const useImpersonate = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: impersonate,
        onSuccess: () => {
            queryClient.invalidateQueries().then(() => {
                navigate('/dashboard');
            });
        },
    });
}


export const useRemoveImpersonate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: removeImpersonate,
        onSuccess: () => {
            queryClient.invalidateQueries().then(() => {});
        },
    });
}